export const USER_DATA = "user_data"
export const USER_TOKENS_DETAILS = "user_token_details"
export const SELECTED_FILTER_VALUE = "selected_filter"
export const SELECTED_SORT_VALUE = "selected_sort_value"
export const SELECTED_FILTER_ID = "selected_filter_id"
export const PAGE_SIZE_ON_NAVIGATION = "page_size_on_navigation"
export const SCROLL_OFFSET = "scroll_offset"
export const CART_COUNT = "cart_count"
export const CART_AMOUNT = 'cart_amount'
export const CART_ID = 'cart_id'
export const LOGOUT_USER = 'logout_user'
export const APP_BANNER = 'app_banner'
export const ACF = "acf"
export const ALL_CATEGORIES = 'all_categories'
export const ALL_SPECIAL_CATEGORIES = 'all_special_categories'
export const ALL_MERCHANTS = 'all_merchants'
export const TILES = 'tiles'
